import { render, staticRenderFns } from "./FreestyleAudioToggle.vue?vue&type=template&id=b218594a&scoped=true"
import script from "./FreestyleAudioToggle.vue?vue&type=script&lang=js"
export * from "./FreestyleAudioToggle.vue?vue&type=script&lang=js"
import style0 from "./FreestyleAudioToggle.vue?vue&type=style&index=0&id=b218594a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218594a",
  null
  
)

export default component.exports